var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy"},[_vm._v("Copyright © 1968-2022 美的集团 版权所有")])
}
var staticRenderFns = []

export { render, staticRenderFns }